import { useQuery } from "react-query";
import { fetchShopifyReauthUrl } from "../api/rest/shopifyReauth";

export const useFetchShopifyReauthUrl = (enabled: boolean) =>
  useQuery(["shopifyReauthUrl"], fetchShopifyReauthUrl, {
    retry: false,
    enabled,
    staleTime: 5 * 60 * 1000,
  });
